// TODO: Convert to TS and move to @app/router
const pageRoot = {
  legal: '/legal',
};

export const route_path = {
  // Common Routes
  main: '/',
  admin: '/admin/',
  login: '/login/',
  register: '/register/',
  passwordReset: '/password-reset/',
  logout: '/logout',
  about: '/about/',
  // Блог живёт на голом домене (domain-split): со classic.* относительная ссылка была бы битой
  blog: 'https://wonderslide.com/blog/',
  features: '/features/',
  pricing: '/pricing/',
  templates: '/templates/',
  terms: `/terms/`,
  privacy: '/privacy/',
  cookie: '/cookie/',
  // Legal routes
  legal: `${pageRoot.legal}/`,
  legal_terms: `${pageRoot.legal}/terms/`,
  legal_privacy: `${pageRoot.legal}/privacy/`,
  legal_cookie: `${pageRoot.legal}/cookie/`,
  // Team routes
  team: '/team/',
  teamAttribute: '/team/attribute/',
  // Projects routes
  projects: '/projects/',
  // Presentation Creation
  create: '/create/',
  setupStyle: '/create/setup-style/',
  uploadDraft: '/create/upload-draft/',
  // Workspace
  workspace: '/workspace/',
  workspaceCreate: '/workspace/create/',
  workspaceSetupStyle: '/workspace/create/setup-style/',
  workspaceUploadDraft: '/workspace/create/upload-draft/',
  // Create with AI
  textToSlides: '/workspace/text-to-slides/',
  textToSlidesPreview: '/workspace/text-to-slides-preview/',
  // New Chat Widget
  newChat: '/workspace/new-chat/',
  // Redirects
  redirectPayment: '/redirect-payment/',
  notFound: '/404/',
  // Dom-based editor (dev only)
  domEditor: '/dom-editor/',
  // Special paths (without language prefix)
  sharing: '/s/',
} as const;

/**
 * Специальные пути, которые не должны иметь языковой префикс
 * - Sharing links: /s/:token
 * - Admin: /admin/*
 */
export const SPECIAL_PATHS = [route_path.sharing, route_path.admin] as const;

/**
 * Проверяет, является ли путь специальным (не должен иметь языковой префикс)
 * @param path - Путь для проверки
 * @returns true, если путь специальный
 */
export const isSpecialPath = (path: string): boolean => {
  return SPECIAL_PATHS.some((specialPath) => path.startsWith(specialPath));
};

/**
 * Пути, на которых не показывается футер
 */
export const WITHOUT_FOOTER_LOCATIONS = ['create', 'workspace'] as const;

/**
 * Список защищенных маршрутов (требуют авторизации)
 */
export const PROTECTED_ROUTE_LIST = [
  'create',
  'projects',
  'setup-style',
  'upload-draft',
  'text-to-slides',
  'workspace',
] as const;
